<template>
  <div>
    <!-- ABRE CREATE ITEM -->
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="modalCreateItem"
      title="ADICIONAR ITEM"
    >
      <div class="row">
        <!-- ABRE PRODUCT -->
        <div
          class="col-md-12 pb-0"
          v-if="type === 'PRODUCT' && !list_item_product_id"
        >
          <SelectProductID
            :showProduct="false"
            v-on:selected="selectedProduct"
          />
        </div>
        <div
          class="col-md-12 pb-0"
          v-if="type === 'PRODUCT' && list_item_product_id"
        >
          <label>NOME</label>
          <input
            disabled
            v-model="list_item_product.name"
            type="text"
            class="form-control"
          />
          <button
            type="button"
            class="btn btn-sm btn-dark mt-2 text-white"
            @click="selecionarOutroItem"
          >
            Escolher outro
          </button>
        </div>
        <!-- FECHA PRODUCT -->
        <!-- ABRE MEDICINE -->
        <div
          class="col-md-12 pb-0"
          v-if="type === 'MEDICINE' && !list_item_medicine_id"
        >
          <SelectMedicineID
            :showMedicine="false"
            :newMedicine="false"
            v-on:selected="selectedMedicine"
          />
        </div>
        <div
          class="col-md-12 pb-0"
          v-if="type === 'MEDICINE' && list_item_medicine_id"
        >
          <label>NOME COMERCIAL</label>
          <input
            disabled
            v-model="list_item_medicine.name"
            type="text"
            class="form-control"
          />
          <button
            type="button"
            class="btn btn-sm btn-dark mt-2 text-white"
            @click="selecionarOutroItem"
          >
            Escolher outro
          </button>
        </div>
        <!-- FECHA MEDICINE -->
        <!-- <div class="col-md-6 pb-0">
          <label-required-field label="Quantidade por vez" />
          <input
            type="text"
            v-model="list_item_quantity"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Quantidade de vezes ao dia" />
          <input
            type="number"
            v-model="list_item_how_many_times"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Quantos dias de estoque mínimo" />
          <input
            type="number"
            v-model="list_item_days_minimum_stock"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Estoque atual" />
          <input
            type="number"
            v-model="list_item_current_stock"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Estoque faltante" />
          <input
            type="number"
            v-model="list_item_missing_stock"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Estoque mínimo" />
          <input
            type="number"
            v-model="list_item_minimum_stock"
            class="form-control"
          />
        </div> -->
        <div class="col-md-12 pb-0">
          <label>Observação</label>
          <input type="text" v-model="list_item_note" class="form-control" />
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-12 text-right">
          <v-btn
            :disabled="loadingCreateItem"
            type="button"
            class="btn-save"
            @click="createItemList"
          >
            <i class="fas fa-save mr-2 text-twenty" />
            {{ loadingCreateItem ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- FECHA CREATE ITEM -->

    <!-- ABRE UPDATE ITEM -->
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="modalUpdateItem"
      title="EDITAR ITEM"
    >
      <div class="row">
        <!-- <div class="col-md-6 pb-0">
          <label-required-field label="Quantidade por vez" />
          <div class="input-group">
            <input
              type="text"
              v-model="list_item_quantity"
              class="form-control"
            />
            <div class="input-group-pprend">
              <input type="text" class="form-control" disabled value="x" />
            </div>
          </div>
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Quantidade de vezes ao dia" />
          <input
            type="number"
            v-model="list_item_how_many_times"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Quantos dias de estoque mínimo" />
          <input
            type="number"
            v-model="list_item_days_minimum_stock"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Estoque atual" />
          <input
            type="number"
            v-model="list_item_current_stock"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Estoque faltante" />
          <input
            type="number"
            v-model="list_item_missing_stock"
            class="form-control"
          />
        </div>
        <div class="col-md-6 pb-0">
          <label-required-field label="Estoque mínimo" />
          <input
            type="number"
            v-model="list_item_minimum_stock"
            class="form-control"
          />
        </div> -->
        <div class="col-md-12 pb-0">
          <label>Observação</label>
          <input type="text" v-model="list_item_note" class="form-control" />
        </div>
        <div class="col-md-12 pb-0">
          <label-required-field label="Ativo/Inativo" />
          <select class="form-control" v-model="list_item_status">
            <option value="1">ATIVA</option>
            <option value="0">INATIVA</option>
          </select>
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-12 text-right">
          <v-btn
            :disabled="loadingUpdateItem"
            type="button"
            class="btn-save"
            @click="updateListItem"
          >
            <i class="fas fa-save mr-2 text-twenty" />
            {{ loadingUpdateItem ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- FECHA UPDATE ITEM -->

    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div v-if="!list" class="text-center alert alert-warning">
          <h1>LISTA NÃO ENCONTRADA!</h1>
        </div>
        <div v-else>
          <div class="row bg-white mb-2">
            <div class="col-md-12 text-right">
              <confirmation-dialog
                v-if="permission('remove', 'list')"
                message-title="EXCLUIR?"
                message-body="Deseja realmente excluir a lista?"
                open-class="btn-delete"
                open-left-icon="fa-trash"
                open-text="EXCLUIR"
                @yes="deleteList"
              />
            </div>
            <div class="col-md-4 pb-0">
              <label-required-field label="Ativa/Inativa" />
              <select class="form-control" v-model="status">
                <option :selected="list.status == 1" value="1">ATIVA</option>
                <option :selected="list.status == 0" value="0">INATIVA</option>
              </select>
            </div>
            <div class="col-md-8 pb-0">
              <label-required-field label="Nome" />
              <input type="text" v-model="description" class="form-control" />
            </div>
            <div class="col-md-12 pb-0">
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12 pt-0 text-right">
              <v-btn
                :disabled="loadingUpdate"
                type="button"
                class="btn-save"
                @click="updateList"
              >
                <i class="fas fa-save mr-2 text-twenty" />
                {{ loadingUpdate ? "Carregando" : "SALVAR" }}
              </v-btn>
            </div>
          </div>

          <div class="row bg-white">
            <div class="col-md-12 text-center">
              <v-btn
                v-if="permission('edit', 'list')"
                @click="handleModalCreateItem"
                class="btn-add m-1"
                ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
                {{ list.type == "PRODUCT" ? "PRODUTO" : "MEDICAMENTO" }}</v-btn
              >
            </div>
            <div class="col-md-12">
              <div
                class="v-clean p-5 text-center"
                v-show="list_items.length == 0"
              >
                <h6 class="text-center upper-text worksansr">
                  SEM RESULTADOS!
                </h6>
              </div>
              <v-data-table
                v-show="list_items.length > 0"
                dense
                :headers="listItemsHeaders"
                :items="list_items"
                :footer-props="{
                  'items-per-page-options': [50, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
              >
                <template v-slot:[`item.status`]="{ item }">
                  <span v-if="item.status == 1">ATIVO</span>
                  <span v-if="item.status == 0">INATIVO</span>
                </template>
                <template v-slot:[`item.list_item_name`]="{ item }">
                  <span v-if="item.product_id">{{ item.product_name }}</span>
                  <span v-if="item.medicine_id">{{ item.medicine_name }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <confirmation-dialog
                    v-if="permission('remove', 'list')"
                    message-title="EXCLUIR?"
                    message-body="Deseja realmente remover o item da lista?"
                    open-class="btn-delete m-1"
                    open-left-icon="fa-trash"
                    open-text="EXCLUIR"
                    x_small
                    @yes="deleteListItem(item.id)"
                  />
                  <v-btn
                    x-small
                    class="btn-edit m-1"
                    @click="handleModalUpdateItemList(item)"
                  >
                    <i class="fas fa-pencil-alt mr-2" /> EDITAR
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../lib/format";

import permission from "../../lib/permission";

import ErrorsMessages from "../Components/ErrorsMessages";

import LabelRequiredField from "../Components/LabelRequiredField";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import SelectMedicineID from "../Components/SelectMedicineID";
import SelectProductID from "../Components/SelectProductID";

import moment from "moment";

export default {
  name: "ListDetails",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    ConfirmationDialog,
    SelectMedicineID,
    SelectProductID,
  },

  data() {
    return {
      listItemsHeaders: [
        { text: "Situação", value: "status" },
        { text: "Nome", value: "list_item_name" },
        // { text: "Quantidade por vez", value: "quantity" },
        // { text: "Quantidade de vezes ao dia", value: "how_many_times" },
        // { text: "Quantos dias de estoque mínimo", value: "days_minimum_stock" },
        // { text: "Estoque atual", value: "current_stock" },
        // { text: "Estoque faltando", value: "missing_stock" },
        // { text: "Estoque mínimo", value: "minimum_stock" },
        { text: "Observação", value: "note" },
        { text: "Ações", value: "actions" },
      ],

      type: null,

      list_item_medicine_id: null,
      list_item_medicine: null,
      list_item_product_id: null,
      list_item_product: null,

      status: 1,
      description: "",
      list: null,
      list_items: [],

      list_item_id: "",
      list_item_quantity: "",
      list_item_how_many_times: "",
      list_item_days_minimum_stock: "",
      list_item_current_stock: "",
      list_item_missing_stock: "",
      list_item_minimum_stock: "",
      list_item_note: "",
      list_item_status: 1,

      errors: [],

      loading: false,
      loadingUpdate: false,
      loadingDelete: false,
      loadingCreateItem: false,
      loadingUpdateItem: false,
      loadingDeleteItem: false,
    };
  },

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,
    moment,

    handleModalCreateItem() {
      this.selecionarOutroItem();

      this.list_item_medicine_id = "";
      this.list_item_product_id = "";
      this.list_item_quantity = "";
      this.list_item_how_many_times = "";
      this.list_item_days_minimum_stock = "";
      this.list_item_current_stock = "";
      this.list_item_missing_stock = "";
      this.list_item_minimum_stock = "";
      this.list_item_note = "";
      this.list_item_status = 1;

      this.$bvModal.show("modalCreateItem");
    },

    selecionarOutroItem() {
      this.list_item_medicine_id = null;
      this.list_item_medicine = null;
      this.list_item_product_id = null;
      this.list_item_product = null;
    },

    selectedProduct(product) {
      this.list_item_product_id = null;
      this.list_item_product = null;
      if (product.id) {
        this.list_item_product = product;
        this.list_item_product_id = product.id;
      }
    },

    selectedMedicine(medicine) {
      this.list_item_medicine_id = null;
      this.list_item_medicine = null;
      if (medicine.id) {
        this.list_item_medicine = medicine;
        this.list_item_medicine_id = medicine.id;
      }
    },

    handleModalUpdateItemList(item) {
      this.list_item_id = item.id;
      this.list_item_quantity = item.quantity;
      this.list_item_how_many_times = item.how_many_times;
      this.list_item_days_minimum_stock = item.days_minimum_stock;
      this.list_item_current_stock = item.current_stock;
      this.list_item_missing_stock = item.missing_stock;
      this.list_item_minimum_stock = item.minimum_stock;
      this.list_item_note = item.note;
      this.list_item_status = item.status;

      this.$bvModal.show("modalUpdateItem");
    },

    retrieve() {
      this.getById();
      this.getItemsById();
    },

    async getById() {
      try {
        this.loading = true;

        let { id } = this;

        let params = {
          id,
        };

        let response = await api.get("/rest-home/list", {
          params,
        });

        let { error, errors, list } = response.data;

        this.loading = false;

        if (!error) {
          this.list = list;
          this.type = list.type;
          this.description = list.description;
          this.status = list.status;
          this.errors = [];
        } else {
          this.list = null;
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async getItemsById() {
      try {
        this.loading = true;

        let { id: list_id } = this;

        let params = { list_id };

        let response = await api.get("/rest-home/list-items", {
          params,
        });

        let { list_items } = response.data;

        this.loading = false;

        this.list_items = list_items;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async updateList() {
      try {
        this.loadingUpdate = true;

        let { id, description, status } = this;

        let params = { id, description, status };

        let response = await api.put("/rest-home/list", params);

        let { error, errors } = response.data;

        if (!error) {
          this.getById();
        } else {
          this.errors = errors;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createItemList() {
      try {
        this.loadingCreateItem = true;

        let {
          id: list_id,
          list_item_medicine_id: medicine_id,
          list_item_product_id: product_id,
          list_item_quantity: quantity,
          list_item_how_many_times: how_many_times,
          list_item_days_minimum_stock: days_minimum_stock,
          list_item_current_stock: current_stock,
          list_item_missing_stock: missing_stock,
          list_item_minimum_stock: minimum_stock,
          list_item_note: note,
        } = this;

        let params = {
          list_id,
          product_id,
          medicine_id,
          quantity,
          how_many_times,
          days_minimum_stock,
          current_stock,
          missing_stock,
          minimum_stock,
          note,
        };

        let response = await api.post("/rest-home/list-item", params);

        let { error, errors } = response.data;

        if (!error) {
          this.getById();
          this.getItemsById();

          this.$bvModal.hide("modalCreateItem");
        } else {
          this.errors = errors;
        }

        this.loadingCreateItem = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateListItem() {
      try {
        this.loadingDeleteItem = true;

        let {
          list_item_id: id,
          list_item_medicine_id: medicine_id,
          list_item_product_id: product_id,
          list_item_quantity: quantity,
          list_item_how_many_times: how_many_times,
          list_item_days_minimum_stock: days_minimum_stock,
          list_item_current_stock: current_stock,
          list_item_missing_stock: missing_stock,
          list_item_minimum_stock: minimum_stock,
          list_item_note: note,
          list_item_status: status,
        } = this;

        let params = {
          id,
          product_id,
          medicine_id,
          quantity,
          how_many_times,
          days_minimum_stock,
          current_stock,
          missing_stock,
          minimum_stock,
          note,
          status,
        };

        let response = await api.put("/rest-home/list-item", params);

        let { error, errors } = response.data;

        if (!error) {
          this.getItemsById();
          this.$bvModal.hide("modalUpdateItem");
        } else {
          this.errors = errors;
        }

        this.loadingDeleteItem = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteListItem(id) {
      try {
        this.loadingDeleteItem = true;

        let data = { id };

        let response = await api.delete("/rest-home/list-item", {
          data,
        });

        let { error, errors } = response.data;

        if (!error) {
          this.getItemsById();
        } else {
          this.errors = errors;
        }

        this.loadingDeleteItem = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteList() {
      try {
        this.loadingDelete = true;

        let { id } = this;

        let data = { id };

        let response = await api.delete("/rest-home/list", {
          data,
        });

        let { error, errors } = response.data;

        if (!error) {
          this.$router.push("/lists");
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
